import { render, staticRenderFns } from "./lista_autoridades_institucion.vue?vue&type=template&id=4521201e&scoped=true"
import script from "./lista_autoridades_institucion.vue?vue&type=script&lang=js"
export * from "./lista_autoridades_institucion.vue?vue&type=script&lang=js"
import style0 from "./lista_autoridades_institucion.vue?vue&type=style&index=0&id=4521201e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521201e",
  null
  
)

export default component.exports